module.exports = __webpack_public_path__ + "img/tiff.6857b75e.png";